// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/registration/kyc/firstparty/v1/get_kyc_status.proto

/* oxlint-disable */

/**
 * The KYC provider handling the verification.
 */
export const ApiProvider = {
  /** idnow_videoident - IDnow video identification provider. */
  idnow_videoident: "idnow_videoident",
  /** fourthline - Fourthline KYC provider. */
  fourthline: "fourthline",
} as const;

export type ApiProvider = typeof ApiProvider[keyof typeof ApiProvider];

export namespace ApiProvider {
  export type idnow_videoident = typeof ApiProvider.idnow_videoident;
  export type fourthline = typeof ApiProvider.fourthline;
}

export function apiProviderFromJSON(object: any): ApiProvider {
  switch (object) {
    case 0:
    case "idnow_videoident":
      return ApiProvider.idnow_videoident;
    case 1:
    case "fourthline":
      return ApiProvider.fourthline;
    default:
      return ApiProvider.idnow_videoident;
  }
}

export function apiProviderToJSON(object: ApiProvider): string {
  switch (object) {
    case ApiProvider.idnow_videoident:
      return "idnow_videoident";
    case ApiProvider.fourthline:
      return "fourthline";
    default:
      return "idnow_videoident";
  }
}

/**
 * The status of the KYC verification process.
 */
export const ApiProviderStatus = {
  /** pending - Verification is pending and has not yet started. */
  pending: "pending",
  /** on_call - Verification call is in progress. */
  on_call: "on_call",
  /** succeeded - Verification completed successfully. */
  succeeded: "succeeded",
  /** failed - Verification failed. */
  failed: "failed",
  /** canceled - Verification was canceled by the user. */
  canceled: "canceled",
  /** waiting_results - Verification completed, awaiting results. */
  waiting_results: "waiting_results",
  /** rejected - Verification was rejected. */
  rejected: "rejected",
  /** kyc_required - KYC verification is required. */
  kyc_required: "kyc_required",
  /** qes_required - QES (Qualified Electronic Signature) is required. */
  qes_required: "qes_required",
  /** process_finished - KYC process has finished. */
  process_finished: "process_finished",
} as const;

export type ApiProviderStatus = typeof ApiProviderStatus[keyof typeof ApiProviderStatus];

export namespace ApiProviderStatus {
  export type pending = typeof ApiProviderStatus.pending;
  export type on_call = typeof ApiProviderStatus.on_call;
  export type succeeded = typeof ApiProviderStatus.succeeded;
  export type failed = typeof ApiProviderStatus.failed;
  export type canceled = typeof ApiProviderStatus.canceled;
  export type waiting_results = typeof ApiProviderStatus.waiting_results;
  export type rejected = typeof ApiProviderStatus.rejected;
  export type kyc_required = typeof ApiProviderStatus.kyc_required;
  export type qes_required = typeof ApiProviderStatus.qes_required;
  export type process_finished = typeof ApiProviderStatus.process_finished;
}

export function apiProviderStatusFromJSON(object: any): ApiProviderStatus {
  switch (object) {
    case 0:
    case "pending":
      return ApiProviderStatus.pending;
    case 1:
    case "on_call":
      return ApiProviderStatus.on_call;
    case 2:
    case "succeeded":
      return ApiProviderStatus.succeeded;
    case 3:
    case "failed":
      return ApiProviderStatus.failed;
    case 4:
    case "canceled":
      return ApiProviderStatus.canceled;
    case 5:
    case "waiting_results":
      return ApiProviderStatus.waiting_results;
    case 6:
    case "rejected":
      return ApiProviderStatus.rejected;
    case 7:
    case "kyc_required":
      return ApiProviderStatus.kyc_required;
    case 8:
    case "qes_required":
      return ApiProviderStatus.qes_required;
    case 9:
    case "process_finished":
      return ApiProviderStatus.process_finished;
    default:
      return ApiProviderStatus.pending;
  }
}

export function apiProviderStatusToJSON(object: ApiProviderStatus): string {
  switch (object) {
    case ApiProviderStatus.pending:
      return "pending";
    case ApiProviderStatus.on_call:
      return "on_call";
    case ApiProviderStatus.succeeded:
      return "succeeded";
    case ApiProviderStatus.failed:
      return "failed";
    case ApiProviderStatus.canceled:
      return "canceled";
    case ApiProviderStatus.waiting_results:
      return "waiting_results";
    case ApiProviderStatus.rejected:
      return "rejected";
    case ApiProviderStatus.kyc_required:
      return "kyc_required";
    case ApiProviderStatus.qes_required:
      return "qes_required";
    case ApiProviderStatus.process_finished:
      return "process_finished";
    default:
      return "pending";
  }
}

/** Request message for retrieving the KYC status of a stakeholder. */
export interface ApiGetKYCStatusRequest {
  /** The ID of the stakeholder to retrieve KYC status for. */
  readonly stakeholderId: string;
}

/** Response message containing the KYC status of a stakeholder. */
export interface ApiGetKYCStatusResponse {
  /** The KYC status details. */
  readonly kyc: ApiKYCStatus | null;
}

/** The KYC status for a stakeholder, including provider details and verification state. */
export interface ApiKYCStatus {
  /** The ID of the stakeholder this KYC status belongs to. */
  readonly stakeholderId: string;
  /**
   * The KYC provider handling the verification.
   */
  readonly provider: ApiProvider;
  /** The provider-assigned identifier for this KYC case. */
  readonly providerId: string;
  /** A token used to authenticate with the KYC provider's SDK. */
  readonly providerToken?:
    | string
    | null
    | undefined;
  /**
   * The current status of the KYC verification process.
   */
  readonly providerStatus: ApiProviderStatus;
  /** URL to redirect the user to for completing KYC verification. */
  readonly redirectUrl?:
    | string
    | null
    | undefined;
  /** Whether a Qualified Electronic Signature (QES) is required. */
  readonly isQesRequired?:
    | boolean
    | null
    | undefined;
  /** The device type used for identification (e.g. APP). */
  readonly device?:
    | string
    | null
    | undefined;
  /** The reason for the current KYC status. */
  readonly reason?: string | null | undefined;
}

export const ApiGetKYCStatusRequest: MessageFns<ApiGetKYCStatusRequest> = {
  fromJSON(object: any): ApiGetKYCStatusRequest {
    return { stakeholderId: isSet(object.stakeholder_id) ? globalThis.String(object.stakeholder_id) : "" };
  },

  toJSON(message: ApiGetKYCStatusRequest): unknown {
    const obj: any = {};
    if (message.stakeholderId !== undefined && message.stakeholderId !== null) {
      obj.stakeholder_id = message.stakeholderId;
    }
    return obj;
  },
};

export const ApiGetKYCStatusResponse: MessageFns<ApiGetKYCStatusResponse> = {
  fromJSON(object: any): ApiGetKYCStatusResponse {
    return { kyc: isSet(object.kyc) ? ApiKYCStatus.fromJSON(object.kyc) : null };
  },

  toJSON(message: ApiGetKYCStatusResponse): unknown {
    const obj: any = {};
    if (message.kyc !== undefined && message.kyc !== null) {
      obj.kyc = ApiKYCStatus.toJSON(message.kyc);
    }
    return obj;
  },
};

export const ApiKYCStatus: MessageFns<ApiKYCStatus> = {
  fromJSON(object: any): ApiKYCStatus {
    return {
      stakeholderId: isSet(object.stakeholder_id) ? globalThis.String(object.stakeholder_id) : "",
      provider: isSet(object.provider) ? apiProviderFromJSON(object.provider) : ApiProvider.idnow_videoident,
      providerId: isSet(object.provider_id) ? globalThis.String(object.provider_id) : "",
      providerToken: isSet(object.provider_token) ? globalThis.String(object.provider_token) : null,
      providerStatus: isSet(object.provider_status)
        ? apiProviderStatusFromJSON(object.provider_status)
        : ApiProviderStatus.pending,
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : null,
      isQesRequired: isSet(object.is_qes_required) ? globalThis.Boolean(object.is_qes_required) : null,
      device: isSet(object.device) ? globalThis.String(object.device) : null,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : null,
    };
  },

  toJSON(message: ApiKYCStatus): unknown {
    const obj: any = {};
    if (message.stakeholderId !== undefined && message.stakeholderId !== null) {
      obj.stakeholder_id = message.stakeholderId;
    }
    if (message.provider !== undefined && message.provider !== null) {
      obj.provider = apiProviderToJSON(message.provider);
    }
    if (message.providerId !== undefined && message.providerId !== null) {
      obj.provider_id = message.providerId;
    }
    if (message.providerToken !== undefined && message.providerToken !== null) {
      obj.provider_token = message.providerToken;
    }
    if (message.providerStatus !== undefined && message.providerStatus !== null) {
      obj.provider_status = apiProviderStatusToJSON(message.providerStatus);
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.isQesRequired !== undefined && message.isQesRequired !== null) {
      obj.is_qes_required = message.isQesRequired;
    }
    if (message.device !== undefined && message.device !== null) {
      obj.device = message.device;
    }
    if (message.reason !== undefined && message.reason !== null) {
      obj.reason = message.reason;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
